import * as num from './number-format';

export default function (Handlebars) {
  // Handlebars Subexpressions
  Handlebars.registerHelper('equal', function (a, b) {
    if (a === b) {
      return true;
    } else {
      return false;
    }
  });

  Handlebars.registerHelper('numberToShortTextTags', function (n) {
    return num.toTextTags(num.toShort(n));
  });

  Handlebars.registerHelper('numberToTextTags', function (n) {
    return num.toTextTags(n);
  });

  Handlebars.registerHelper('numberToCommaTags', function (n) {
    return num.toCommaTags(n);
  });

  Handlebars.registerHelper('numberToText', function (n) {
    return num.toText(n);
  });

  Handlebars.registerHelper('addComma', function (n) {
    return num.addComma(parseInt(n, 10));
  });
}
